export const wordListPromise = fetch(new URL('enable2k.txt', import.meta.url))
  .then(response => response.text())
  .then(text => text.trim().split('\n'));
